import Fuse from 'fuse.js';

// Shared fuzzy-search config so the product grid and the header typeahead rank
// results identically. SKU is weighted higher than description, with typo tolerance.
export const FUSE_OPTIONS = {
  keys: [
    { name: 'sku', weight: 0.6 },
    { name: 'description', weight: 0.4 }
  ],
  threshold: 0.4,        // 0 = exact, 1 = match anything; 0.4 tolerates typos
  ignoreLocation: true,  // match anywhere in the field, not just the start
  minMatchCharLength: 2
};

export function createProductFuse(products) {
  return new Fuse(products || [], FUSE_OPTIONS);
}

// Returns products ordered by relevance, or the full list when the query is empty.
export function searchProducts(fuse, products, term) {
  const q = (term || '').trim();
  if (!q) return products;
  return fuse.search(q).map(r => r.item);
}
